import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatTaxiResultCard, RuleActionExtension } from '@sabstravtech/obtservices/base';
import { formatCardCurrency, policyStatusClass, policyStatusLabel } from '../chat-card.util';

@Component({
  selector: 'app-chat-taxi-card',
  standalone: false,
  templateUrl: './chat-taxi-card.component.html',
  styleUrls: ['./chat-taxi-card.component.scss']
})
export class ChatTaxiCardComponent {
  @Input() card!: ChatTaxiResultCard;
  @Output() cardClick = new EventEmitter<void>();

  readonly selectLabel = $localize`:@@chatTaxiSelect:Select`;

  get policyClass(): string {
    return policyStatusClass(this.card.policyStatus);
  }

  get policyLabel(): string {
    return policyStatusLabel(this.policyClass);
  }

  /** Quote's policy fields, shaped for `app-warning-tags` — the same
   *  indicator/tooltip component the results page uses, so the chat card and
   *  results page render identically instead of a bespoke text box. */
  get headlineWarningTicket(): RuleActionExtension {
    return {
      unavailable: !!this.card.unavailable,
      unavailableMessage: this.card.unavailableMessage || '',
      requiresReasonKeys: this.card.requiresReasonKeys || [],
      requiresReasonMessages: this.card.requiresReasonMessages || []
    };
  }

  /** Select the card unless the quote is out of policy and disallowed. */
  onCardClick(): void {
    if (this.card.unavailable) return;
    this.cardClick.emit();
  }

  get formattedPrice(): string {
    return formatCardCurrency(this.card.price, this.card.currencyCode || 'GBP');
  }

  get durationLabel(): string | null {
    if (!this.card.tripDurationSeconds) return null;
    const mins = Math.round(this.card.tripDurationSeconds / 60);
    if (mins < 60) return `${mins}m`;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  }
}
